<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <v-sheet>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Date</th>
                                <td>{{formatDate(value.date)}}</td>
                            </tr>
                            <tr>
                                <th>Code</th>
                                <td>{{value.code}}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>
                                    <PStatus :state="value.state"/> 
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <v-sheet>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Warehouse</th>
                                <td>{{value.warehouse ? value.warehouse.name : null}}</td>
                            </tr>
                            <tr>
                                <th>Receiving Point</th>
                                <td>{{value.receiving_point}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" md="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Ordered</th>
                            <th>Remaining</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, i) in lines" :key="i">
                            <td>{{ i + 1 }}</td>
                            <td>{{l.item}}</td>
                            <td>{{l.description}}</td>
                            <td>{{ l.quantity}} {{ l.measure_unit }}</td>
                            <td>
                                <span v-if="l.ordered > 0">{{ l.ordered }} {{ l.measure_unit }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span v-if="(l.quantity - l.ordered) != 0">{{ l.quantity - l.ordered }} {{ l.measure_unit }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <v-icon v-if="l.ordered == 0" color="grey lighten-2">mdi-check-circle</v-icon>
                                <v-icon v-if="l.ordered > 0 && l.ordered < l.quantity" color="warning">mdi-alert-circle</v-icon>
                                <v-icon v-if="l.ordered == l.quantity" color="success">mdi-check-circle</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Notes</th>
                            <td>{{value.notes}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>  
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr v-if="value.created_by">
                            <th>Created by</th>
                            <td>{{value.created_by.name}}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{formatDatetime(value.created_at)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment';
import PStatus from './../common/PStatus.vue'

export default {
    name: "PurchaseRequisition",
    components: {
        PStatus
    },
    props: {
        value: {
            type: Object
        }
    },
    computed: {
        lines() {
            return this.value.lines?.map(line => ({
                ...line,
                item: `${line.item.code} - ${line.item.name}`,
                measure_unit: line.measure_unit.abbreviation,
            }))
        },
       
       
    },
    methods: {
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        formatDatetime(datetime) {
            return moment(datetime).format("YYYY-MM-DD HH:MM:SS")
        }
    }
}
</script>

<style>

</style>